import React from 'react';

import { FeatureService } from './FeatureService';

export interface FeatureContextProps {
  featureService: FeatureService;
}

export const FeatureContext = React.createContext<FeatureContextProps>(undefined!);
